import { Layout } from 'antd';
import get from 'lodash/get';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import type { AppRouter, TRoutes } from '@tools/ui/types';
import useRouter from '@tools/ui-hooks/useRouter.hook';
import PageContent from './PageContent';
import SideContainer from './SideContainer/SideContainer';

const AppLayout = styled(Layout)`
  min-height: 100vh;
`;
type TProps = {
  router: TRoutes | AppRouter;
  extraComponent?: React.FC<React.PropsWithChildren>;
};

const PageContainer: React.FC<React.PropsWithChildren<TProps>> = ({
  router,
  extraComponent: ExtraComponent,
}) => {
  const { pathname, replace } = useRouter();
  const [defaultRoute, ...routes] = (router as AppRouter).modules || (router as TRoutes);

  const menuItemsRouteToShow = React.useMemo(() => {
    return routes.filter((route) => !route.hideFromMenu);
  }, [routes]);

  const selectedKeyRoute = React.useMemo(
    () => menuItemsRouteToShow.findIndex(({ path }) => pathname.includes(path as string)),
    [pathname, menuItemsRouteToShow],
  );

  useEffect(() => {
    const redirectPath = get(defaultRoute, 'redirectFrom[0]');
    if ([pathname, `${pathname}/`].includes(`${redirectPath}/`.replace(`//`, `/`))) {
      replace(menuItemsRouteToShow[0]?.path);
    }
  }, [defaultRoute, replace, pathname, menuItemsRouteToShow, routes]);

  return (
    <AppLayout>
      <SideContainer menuItemsRoute={menuItemsRouteToShow} selectedKeyRoute={selectedKeyRoute} />
      <PageContent defaultRoute={defaultRoute} routes={routes} />
      {ExtraComponent ? <ExtraComponent /> : null}
    </AppLayout>
  );
};
export default React.memo(PageContainer);
